import { render, staticRenderFns } from "./vehicle-main-detail.vue?vue&type=template&id=10273104"
import script from "./vehicle-main-detail.vue?vue&type=script&lang=js"
export * from "./vehicle-main-detail.vue?vue&type=script&lang=js"
import style0 from "./vehicle-main-detail.vue?vue&type=style&index=0&id=10273104&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports